<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item   label="身份证号：">
              <el-input   v-model="form.idCard" 
                    placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('rycctjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._h"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/人员抽查统计表--导入.xls" download="人员抽查统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          width="100px"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          prop="areaName"
          label="行政区域"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="totalCount"
          label="任务总数"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="抽查结果"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo1"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
          <el-table-column
            label="信息不符合"
            align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo2"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="未接通"
            align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo3"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="分布情况"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo4"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="人员抽查统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item> 
                        <el-form-item label="人员状态：">
                          <el-select size="mini" filterable v-model="editForm.personStatus" placeholder="请选择">
                            <el-option
                              v-for="item in $public.dangQianZT"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item> 
                        <el-form-item label="脱贫状态：">
                          <el-select size="mini" filterable v-model="editForm.poorStatus" placeholder="请选择">
                            <el-option
                              v-for="item in $public.tuopinzhuangtai"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系方式：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="抽查地区：">
                          <el-input style="width:193px;" v-model="editForm.checkArea"></el-input>
                        </el-form-item>
                        <el-form-item label="抽查时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.checkTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="抽查结果：">
                          <el-select size="mini" filterable v-model="editForm.checkResult" placeholder="请选择">
                            <el-option
                              v-for="item in $public.chouchajieguo"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="其它原因：">
                          <el-input style="width:193px;" v-model="editForm.otherReason"></el-input>
                        </el-form-item>
                        <el-form-item label="人员类型：">
                          <el-select size="mini" filterable v-model="editForm.personType" placeholder="请选择">
                            <el-option
                              v-for="item in $public.renyuanleixing"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="年龄：">
                          <el-input style="width:193px;" v-model="editForm.age"></el-input>
                        </el-form-item>
                        <el-form-item label="核实情况：">
                          <el-select size="mini" filterable v-model="editForm.auditStatus" placeholder="请选择">
                            <el-option
                              v-for="item in $public.heShiQK"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="省平台户口所在地：">
                          <el-input style="width:193px;" v-model="editForm.residence"></el-input>
                        </el-form-item>
                        <el-form-item label="劳动能力：">
                          <el-select size="mini" filterable v-model="editForm.laborCapacity" placeholder="请选择">
                            <el-option
                              v-for="item in $public.laoDongNL"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="技能等级：">
                          <el-select size="mini" filterable v-model="editForm.skillLevel" placeholder="请选择">
                            <el-option
                              v-for="item in $public.jiNengDJ"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="两后生：">
                          <el-select size="mini" filterable v-model="editForm.twoAfter" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="文化程度：">
                          <el-select size="mini" filterable v-model="editForm.education" placeholder="请选择">
                            <el-option
                              v-for="item in $public.wenHuaCD"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="毕业时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.graduationTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否就业：">
                          <el-select size="mini" filterable v-model="editForm.hasJob" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="就业意愿：">
                          <el-input style="width:193px;" v-model="editForm.jobIntention"></el-input>
                        </el-form-item>
                        <el-form-item label="参加培训情况：">
                          <el-select size="mini" filterable v-model="editForm.training" placeholder="请选择">
                            <el-option
                              v-for="item in $public.canJiaPeiXunQK"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="培训意愿：">
                          <el-select size="mini" filterable v-model="editForm.traingIntention" placeholder="请选择">
                            <el-option
                              v-for="item in $public.options1"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="就业时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.workTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="就业地点：">
                          <el-input style="width:193px;" v-model="editForm.workAddress"></el-input>
                        </el-form-item>
                        <el-form-item label="就业形式：">
                          <el-select size="mini" filterable v-model="editForm.workStyle" placeholder="请选择">
                            <el-option
                              v-for="item in $public.jiuYeXS"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="就业单位名称：">
                          <el-input style="width:193px;" v-model="editForm.organizationName"></el-input>
                        </el-form-item>
                        <el-form-item label="单位性质：">
                          <el-input style="width:193px;" v-model="editForm.organizationType"></el-input>
                        </el-form-item>
                        <el-form-item label="就业岗位：">
                          <el-input style="width:193px;" v-model="editForm.job"></el-input>
                        </el-form-item>
                        <el-form-item label="月均工资：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <el-form-item label="操作人：">
                          <el-input style="width:193px;" v-model="editForm.dealUser"></el-input>
                        </el-form-item>
                        <el-form-item label="操作时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.dealTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      form:{},
      type:'6',
      api:'/user/personCheck',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'name',value:'姓名'},
        {key:'idCard',value:'身份证'},
        {key:'personStatus',value:'人员状态'},
        {key:'poorStatus',value:'脱贫状态'},
        {key:'phone',value:'联系方式'},
        {key:'checkArea',value:'抽查地区'},
        {key:'checkTime',value:'抽查时间'},
        {key:'checkResult',value:'抽查结果'},
        {key:'otherReason',value:'其它原因'},
        {key:'personType',value:'人员类型'},
        {key:'age',value:'年龄'},
        {key:'auditStatus',value:'核实情况'},
        {key:'residence',value:'省平台户口所在地'},
        {key:'laborCapacity',value:'劳动能力'},
        {key:'skillLevel',value:'技能等级'},
        {key:'twoAfter',value:'两后生'},
        {key:'education',value:'文化程度'},
        {key:'graduationTime',value:'毕业时间'},
        {key:'hasJob',value:'是否就业'},
        {key:'jobIntention',value:'就业意愿'},
        {key:'training',value:'参加培训情况'},
        {key:'traingIntention',value:'培训意愿'},
        {key:'workTime',value:'就业时间'},
        {key:'workAddress',value:'就业地点'},
        {key:'workStyle',value:'就业形式'},
        {key:'organizationName',value:'就业单位名称'},
        {key:'organizationType',value:'单位性质'},
        {key:'job',value:'就业岗位'},
        {key:'salary',value:'月均工资'},
        {key:'dealUser',value:'操作人'},
        {key:'dealTime',value:'操作时间'},
      ],
      baseInfo1:[
        {key: 'taskDoneCount', value: '已抽查总数'},
        {key: 'matchCount', value: '信息相符'},
        {key: 'matchPercent', value: '信息相符占比'},
      ],
      baseInfo2:[
        {key: 'baseInfoMismatch', value: '基本信息不符'},
        {key: 'trainingMismatch', value: '培训情况不符合'},
        {key: 'trainingWishMismatch', value: '培训意愿不符合'},
        {key: 'transferWorkMismatch', value: '已转移就业情况不符合'},
        {key: 'untransferWorkMismatch', value: '未转移就业情况不符合'},
        {key:'workWishMismatch',value:'就业意愿情况不符合'},
        {key:'policyInfoMismatch',value:'政策经办信息不符'},
      ],
      baseInfo3:[
        {key: 'unconnectStop', value: '停机'},
        {key: 'unconnectEmpty', value: '空号'},
        {key: 'unconnectClose', value: '关机'},
        {key: 'unconnectNoanswer', value: '无人应答'},
        {key: 'unconnectNowish', value: '不配合调查'},
        {key:'unconnectOther',value:'其它'},
      ],
      baseInfo4:[
        {key: 'newWork', value: '新增就业'},
        {key: 'unworkHaveWish', value: '未就业有就业意愿'},
        {key: 'policyThrough', value: '政策经办过的'},
        {key: 'traingingWish', value: '有培训意愿'},
        {key: 'transferWork', value: '已转移就业'},
        {key:'untransferWork',value:'未转移就业'},
      ],
      isCreate:false,
      out:false,
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.isShowBtn("PersonCheck")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.checkTime = new Date(newForm.checkTime).getTime()
      newForm.graduationTime = new Date(newForm.graduationTime).getTime()
      newForm.workTime = new Date(newForm.workTime).getTime()
      newForm.dealTime = new Date(newForm.dealTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
    //查询列表
    getData(card) {
      this.$api.getData(this.api,{idCard:card})
      .then(res =>{
        if (res.data.status === 0) {
          this.tableData = JSON.parse(res.data.data)
          this.total = res.data.size
        } else {
          this._status(res.data)
        }
      })
    }
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */

.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}





</style>